/* eslint-disable prettier/prettier */
import { post, get } from '../axios'

// type接口
export function newSize_getTypes_post (map, option) {
  return post(
    `${process.env.VUE_APP_NEWSIZE}/newSize/getTypes`,
    map,
    option
  ).then(response => response)
}

// 修改接口
export function newSize_new_modify_post (map, option) {
  return post(
    `${process.env.VUE_APP_NEWSIZE}/newSize/new/modify`,
    map,
    option
  ).then(response => response)
}

// 新增接口
export function newSize_new_add_post (map, option) {
  return post(
    `${process.env.VUE_APP_NEWSIZE}/newSize/new/add`,
    map,
    option
  ).then(response => response)
}

// 删除单个测量方式
export function newSize_new_delete_id_get (map, option) {
  return get(
    `${process.env.VUE_APP_NEWSIZE}/newSize/new/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 查询单个测量方式
export function newSize_new_query_id_get (map, option) {
  return get(
    `${process.env.VUE_APP_NEWSIZE}/newSize/new/query/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 启用/禁用
export function newSize_new_modifyStatus_id_status_get (map, option) {
  return get(
    `${process.env.VUE_APP_NEWSIZE}/newSize/new/modifyStatus/${map.id}/${map.status}`,
    map,
    option
  ).then(response => response)
}

// 查询接口
export function newSize_new_page_post (map, option) {
  return post(
    `${process.env.VUE_APP_NEWSIZE}/newSize/new/page`,
    map,
    option
  ).then(response => response)
}
